import { useContext } from "react";
import { useSelector } from "react-redux";
import { EditTaskError, Identifiable, Task } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: EditTaskError;
  editTask(request: Boundaries["editTask"]["request"]): void;
}

function useEditTask(task: Identifiable<Task>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditTaskRequestPending(task),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditTaskRequestSuccess(task),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditTaskRequestFailure(task),
    ),
    error: useSelector(() => selector.getEditTaskError(task)),
    editTask: core.editTask,
  };
}

export { useEditTask };
